import React from 'react';

import { TypographyListItem, HourglassEmptyIcon } from '@gogame/components';

import ActionStatus from './ActionStatus';

export const ApproverIcon = ({ isPredicted, actionId }) =>
  isPredicted ? (
    <HourglassEmptyIcon
      fontSize={'small'}
      sx={{ flexShrink: '0', fontSize: 16 }}
    />
  ) : (
    <ActionStatus actionId={actionId} />
  );

export const getApproverLabel = ({ name, role }) => name || role;

export const ApproverListItem = ({
  children,
  name,
  role,
  actionId,
  isPredicted,
  ...props
}) => {
  return (
    <TypographyListItem
      {...props}
      icon={<ApproverIcon isPredicted={isPredicted} actionId={actionId} />}
    >
      {getApproverLabel({ name, role })}
    </TypographyListItem>
  );
};
